import { render, staticRenderFns } from "./kycIcon.vue?vue&type=template&id=9cad9bd0&"
import script from "./kycIcon.vue?vue&type=script&lang=js&"
export * from "./kycIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports